// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"156":"3a1b27ae","453":"321ca493"}[chunkId] + ".chunk.js";
};